module.exports = __webpack_public_path__ + "static/media/moon.912b7d6d.jpg";